<template>
  <el-dialog :title="$t('productCategory.editTitle')" :visible.sync="dialogVisible" width="50%" @close="closeDialog">
    <el-form ref="form" :model="formData" label-width="120px">
      <el-form-item :label="$t('productCategory.categoryName')" prop="categoryName" :rules="[
        { required: true, message: $t('productCategory.nameRequired'), trigger: 'blur' },
        { max: 100, message: $t('productCategory.nameMaxLength'), trigger: 'blur' }
      ]">
        <el-input v-model="formData.categoryName" :placeholder="$t('productCategory.namePlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('productCategory.showOrder')" prop="seq" :rules="[
        { required: true, message: $t('productCategory.orderRequired'), trigger: 'blur' },
        { type: 'number', message: $t('productCategory.orderNumber'), trigger: 'blur' }
      ]">
        <el-input v-model.number="formData.seq" :placeholder="$t('productCategory.orderPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('productCategory.isShow')" prop="isShow" :rules="[
        { required: true, message: $t('productCategory.showRequired'), trigger: 'change' }
      ]">
        <el-select v-model="formData.isShow" :placeholder="$t('productCategory.showPlaceholder')" style="width:100%">
          <el-option v-for="(item, index) in isShows" :key="index" :label="item.name" :value="item.statusCd" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('productCategory.groupType')" prop="cateType" :rules="[
        { required: true, message: $t('productCategory.groupRequired'), trigger: 'change' }
      ]">
        <el-select v-model="formData.cateType" :placeholder="$t('productCategory.groupPlaceholder')" style="width:100%">
          <el-option v-for="(item, index) in cateTypes" :key="index" :label="item.name" :value="item.statusCd" />
        </el-select>
      </el-form-item>
        <el-form-item :label="$t('productCategory.parentCategory')" prop="cateType" :rules="[
        { required: true, message: $t('productCategory.parentRequired'), trigger: 'change' }
      ]">
            <el-select v-model="formData.parentCategoryId" :placeholder="$t('productCategory.parentPlaceholder')" style="width:100%">
                <el-option :label="$t('productCategory.parentTopCategory')" value="-1" />
                <el-option v-for="(item, index) in parentCategories" :key="index" :label="item.categoryName" :value="item.categoryId" />
            </el-select>
        </el-form-item>
        <el-form-item label="目录封面">
            <upload-image-url
                ref="editProductCategoryCover"
                :image-count="1"
                @notifyUploadCoverImage="handleCoverImageUpload">
            </upload-image-url>
        </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="updateProductCategory">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UploadImageUrl from '@/components/system/UploadImageUrl'
import { getDict } from '@/api/shop/shopApi'
import { updateProductCategory,queryProductCategory } from '@/api/goods/productCategoryApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditProductCategory',
    components: {
        UploadImageUrl
    },
  data() {
    return {
      dialogVisible: false,
      formData: {
        categoryId: '',
        categoryName: '',
        seq: '',
        isShow: '',
        cateType: '',
        parentCategoryId: '',
        categoryLevel: '',
        shopId: '',
          coverPhoto: ''
      },
      isShows: [],
      cateTypes: [],
        parentCategories: []
    }
  },
  methods: {
    open(row) {
        // created() {
        //   console.log(JSON.stringify(this.formData))
        //     this.$refs.editProductCategoryCover.setImages([this.formData.coverPhoto])
        // },
      this.dialogVisible = true
      this.formData = { ...row }
        this.formData.seq = parseInt(this.formData.seq)
        this.$nextTick(()=>{
            if (this.formData.coverPhoto) {
                this.$refs.editProductCategoryCover.setImages([this.formData.coverPhoto])
            }else{
                this.$refs.editProductCategoryCover.clearImages()
            }
        })
      this.getDictData()
        this.getParentCategoryData()
    },
    async getDictData() {
      try {
        const { data: isShows } = await getDict('product_category', 'is_show')
        this.isShows = isShows
        const { data: cateTypes } = await getDict('product_category', 'cate_type')
        this.cateTypes = cateTypes
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
      async getParentCategoryData(){
          try{
              let shopId = await getShopId();
              const params = {
                  page: 1,
                  row: 5000,
                  parentCategoryId: '-1',
                  shopId: shopId
              }
              const {data: parentCategories} = await queryProductCategory(params)
              this.parentCategories = parentCategories
          }catch (error) {
              console.error('获取父目录数据失败:', error)
          }
      },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
    },
    async updateProductCategory() {
      try {
        await this.$refs.form.validate()
        let shopId = getShopId()
        this.formData.shopId = shopId
          if (this.formData.parentCategoryId=='-1') {
              this.formData.categoryLevel = '1'
          }else{
              this.formData.categoryLevel = '2'
          }

        await updateProductCategory(this.formData)
        this.$emit('refresh')
        this.$message.success(this.$t('common.editSuccess'))
        this.closeDialog()
      } catch (error) {
        this.$message.error(error)
        console.error('更新失败:', error)
      }
    },
      handleCoverImageUpload(photos) {
          if (photos.length > 0) {
              this.formData.coverPhoto = photos[0]
          } else {
              this.formData.coverPhoto = ''
          }
      },
  }
}
</script>